module.exports = __webpack_public_path__ + "img/35.835e4540.jpg";